import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { API_BASE_URL } from './endPoints';

let loadingContext: { setLoading: (loading: boolean) => void } | null = null;

export const setLoadingContext = (context: { setLoading: (loading: boolean) => void }) => {
  loadingContext = context;
};

export const createApiClient = (): AxiosInstance => {
  const apiClient = axios.create({
    baseURL: API_BASE_URL,
  });

  apiClient.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('authToken');
      if (token) {
        config.headers = config.headers || {};
        (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
      }
      if (loadingContext) {
        loadingContext.setLoading(true);
      }
      return config;
    },
    (error) => {
      if (loadingContext) {
        loadingContext.setLoading(false);
      }
      return Promise.reject(error);
    }
  );

  apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
      if (loadingContext) {
        loadingContext.setLoading(false);
      }
      return response;
    },
    (error) => {
      if (loadingContext) {
        loadingContext.setLoading(false);
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
};

